// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3rf9p","inner":"Footer_inner__2OTlK"};